import { render } from "./headerlogo.vue?vue&type=template&id=3a4f1be6"
const script = {}

import exportComponent from "/Users/zonegoh/Documents/GitHub/levelup/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__